import { PhoneNumberUtil } from "google-libphonenumber";
import { ValidateResult } from "react-hook-form";

const phoneValidator = (value: string): ValidateResult => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (!/^\+\d{3,15}$/.test(value)) {
    return "phoneNumberHelper";
  }

  try {
    return phoneUtil.isValidNumber(phoneUtil.parse(value, "NL"))
      ? true
      : "phoneNumberHelper";
  } catch {
    return "phoneNumberHelper";
  }
};

export default phoneValidator;
